import PROJECT_SUBJECT_OPTIONS from './projectSubjects';

export type DerivedProjectSubject = 'adult' | 'pet';

const PROJECT_SUBJECT_VALUES = new Set<string>(PROJECT_SUBJECT_OPTIONS.map((o) => o.value));

export const isProjectSubject = (value: unknown): value is string =>
  typeof value === 'string' && PROJECT_SUBJECT_VALUES.has(value);

export const deriveProjectSubject = (
  testCategoryName: string | null | undefined,
): DerivedProjectSubject => (testCategoryName?.toLowerCase().includes('pet') ? 'pet' : 'adult');
